import React from 'react';

import useOrganisationSettings from 'components/hooks/useOrganisationSettings';

import { StringModifier, modifyString } from 'constants/copyHelpers';

import { ConfirmationModal } from 'uiToolkitV1/ConfirmationModal';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

export const RealignModal = ({ isOpen, onClose, handleNotRealignChildrenOKRs, handleRealignChildrenOKRs, okrType }) => {
  const { moduleName, objectivesName, keyResultsName } = useOrganisationSettings();

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      title={`Re-align ${moduleName}`}
      body={<ModalBody okrType={okrType} />}
      /* when user chooses to not re-align children i.e. No, he means he wants to re-align children to different timeline */
      cancelText="No"
      onCancel={handleRealignChildrenOKRs}
      /* when user chooses to re-align children i.e. Yes, he means he wants to keep hierarchy as currently shown */
      continueText="Yes"
      onContinue={handleNotRealignChildrenOKRs}
    />
  );
};

const ModalBody = ({ okrType }) => {
  const { moduleName, objectivesName, keyResultsName } = useOrganisationSettings();
  return (
    <TextBodyMedium>
      By re-aligning this {modifyString(moduleName, StringModifier.SENTENCE_CASE)}, do you also wish to re-align the
      entire child {modifyString(moduleName, StringModifier.SENTENCE_CASE)} tree that is aligned to it?
    </TextBodyMedium>
  );
};
